import {
  COMMENTS_ELEMENT_LIST_TAB,
  DEFAULT_ELEMENT_LIST_TABS,
  ElementListItem,
  ElementListTab,
  useElementListItems,
} from '@editor/components/ElementListPane'

const TABS: ElementListTab[] = [...DEFAULT_ELEMENT_LIST_TABS, COMMENTS_ELEMENT_LIST_TAB]

interface ElementListBinding {
  tabs: ElementListTab[]
  itemsByElementType: Record<string, ElementListItem[]>
}

/**
 * Display-only element list for the IFC Import page — lists every element with its id + cross-section
 * / assembly. No selection wiring yet (the page has no per-element selection); the shared pane
 * supports selection so it can be enabled later by passing onSelectionChange.
 */
const useIFCImportElementList = (): ElementListBinding => {
  const itemsByElementType = useElementListItems(TABS)

  return {
    tabs: TABS,
    itemsByElementType,
  }
}

export default useIFCImportElementList
